import type { DisplayMode } from './displayMode';
import { DisplayModeEnum } from './displayMode';

export class DisplayModeFactory {
  from = (renderGatewayView: boolean): DisplayMode => ({
    kind: renderGatewayView
      ? DisplayModeEnum.SEO_OPTIMIZED
      : DisplayModeEnum.NON_SEO_OPTIMIZED,
  });
}
